/* eslint-disable */
import { useTranslation } from "react-i18next";
import { Paper } from "@mui/material";
import React from "react";
import styles from "./Ratings.module.scss";

export default function Ratings({ message }) {
  const { t } = useTranslation();
  return (
    <div className={styles["ratings-container"]}>
      <Paper
        className={styles["rating"]}
        elevation={1}
        style={
          message?.text === "3"
            ? { background: "#01D088", color: "#FFFFFF" }
            : { background: "#EDFFF9" }
        }
      >
        {t("chat:ratingExcellentCaps")}
      </Paper>
      <Paper
        className={styles["rating"]}
        elevation={1}
        style={
          message?.text === "2"
            ? { background: "#8244EB", color: "#FFFFFF" }
            : { background: "#F2F3FF" }
        }
      >
        {t("chat:ratingAverageCaps")}
      </Paper>
      <Paper
        className={styles["rating"]}
        elevation={1}
        style={
          message?.text === "1"
            ? { background: "#FD416C", color: "#FFFFFF" }
            : { background: "#FFEFF2" }
        }
      >
        {t("chat:ratingPoorCaps")}
      </Paper>
    </div>
  );
}
